import React, { Fragment } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs, P } from '../../../AbstractElements';
import HomeView from './HomeView';

const TenantHome = () => {
    return (
        <Fragment>
            <Breadcrumbs parent="Home" title="Home" mainTitle="Home" />
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <HomeView />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default TenantHome